export const CLIENT_ONBOARDING_STEPS = {
                                            'new': 0,
                                            'NewClient': 0,
                                            'edit':0, 
                                            'add_teams':0,
                                            'company_integrations':1,
                                            'Users':1,
                                            'add-users':1,
                                            'Integrations':1,
                                            'integrations':1,
                                            'careers_page':2,
                                            'job_adverts':3,
                                            'email_branding':4,
                                            'privacy_policy':5,
                                            'my_account':6,
                                            'my_integrations':7,
                                            'my_preferences':8,
                                            'complete':9
                                        }